import {
  toLocalDateTime3u4c8ydzr4ubp as toLocalDateTime,
  Companion_getInstance3qu5ydsg8audm as Companion_getInstance,
} from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import {
  format3s5sut20n6a4c as format,
  Companion_getInstance2vzevs5m6d283 as Companion_getInstance_0,
} from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDateTime.mjs';
import {
  Padding_NONE_getInstance3nt67hl4ceygz as Padding_NONE_getInstance,
  Padding_ZERO_getInstance2hdjif6phlc74 as Padding_ZERO_getInstance,
} from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/format/DateTimeFormat.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { char1r4ssccmdfesy as char } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/format/DateTimeFormatBuilder.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_getInstanceem9vodzsunmv as Companion_getInstance_1,
  Companion_getInstance2euvj2567gjrn as Companion_getInstance_2,
  DayOfWeekNames2fcv38sn7lsy4 as DayOfWeekNames,
  MonthNamesfwvovzkezhlb as MonthNames,
} from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/format/LocalDateFormat.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DatePeriod2y4m7pf19ebgd as DatePeriod } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimePeriod.mjs';
import { minushnjyym3nfk5o as minus } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { padStart36w1507hs626a as padStart } from '../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_timeZone() {
  _init_properties_timeFormatting_kt__wivjv6();
  return timeZone;
}
var timeZone;
function get_today() {
  _init_properties_timeFormatting_kt__wivjv6();
  return today;
}
var today;
function format_0(_this__u8e3s4, formatter) {
  _init_properties_timeFormatting_kt__wivjv6();
  return format(toLocalDateTime(_this__u8e3s4, get_timeZone()), formatter);
}
function Formats$mmddyyyy$lambda($this$Format) {
  $this$Format.b1t(Padding_NONE_getInstance());
  char($this$Format, _Char___init__impl__6a9atx(47));
  $this$Format.d1r(Padding_NONE_getInstance());
  char($this$Format, _Char___init__impl__6a9atx(47));
  $this$Format.h1r();
  return Unit_instance;
}
function Formats$mmddyyyy_hmm$lambda($this$Format) {
  $this$Format.b1t(Padding_NONE_getInstance());
  char($this$Format, _Char___init__impl__6a9atx(47));
  $this$Format.d1r(Padding_NONE_getInstance());
  char($this$Format, _Char___init__impl__6a9atx(47));
  $this$Format.h1r();
  char($this$Format, _Char___init__impl__6a9atx(32));
  $this$Format.f1t(Padding_NONE_getInstance());
  char($this$Format, _Char___init__impl__6a9atx(58));
  $this$Format.h1t(Padding_ZERO_getInstance());
  char($this$Format, _Char___init__impl__6a9atx(32));
  $this$Format.g1t('AM', 'PM');
  return Unit_instance;
}
function Formats$hmm$lambda($this$Format) {
  $this$Format.f1t(Padding_NONE_getInstance());
  char($this$Format, _Char___init__impl__6a9atx(58));
  $this$Format.h1t(Padding_ZERO_getInstance());
  char($this$Format, _Char___init__impl__6a9atx(32));
  $this$Format.g1t('AM', 'PM');
  return Unit_instance;
}
function Formats$hmmss$lambda($this$Format) {
  $this$Format.f1t(Padding_NONE_getInstance());
  char($this$Format, _Char___init__impl__6a9atx(58));
  $this$Format.h1t(Padding_ZERO_getInstance());
  char($this$Format, _Char___init__impl__6a9atx(58));
  $this$Format.i1t(Padding_ZERO_getInstance());
  return Unit_instance;
}
function Formats$eeeddmmyyyy_hmm$lambda($this$Format) {
  $this$Format.l1r(Companion_getInstance_1().k1r_1);
  char($this$Format, _Char___init__impl__6a9atx(44));
  char($this$Format, _Char___init__impl__6a9atx(32));
  $this$Format.g1r(Companion_getInstance_2().f1r_1);
  char($this$Format, _Char___init__impl__6a9atx(32));
  $this$Format.d1r(Padding_NONE_getInstance());
  char($this$Format, _Char___init__impl__6a9atx(32));
  $this$Format.h1r();
  char($this$Format, _Char___init__impl__6a9atx(32));
  $this$Format.f1t(Padding_NONE_getInstance());
  char($this$Format, _Char___init__impl__6a9atx(58));
  $this$Format.h1t(Padding_ZERO_getInstance());
  char($this$Format, _Char___init__impl__6a9atx(32));
  $this$Format.g1t('AM', 'PM');
  return Unit_instance;
}
function Formats$naturalEnglish$lambda($this$Format) {
  $this$Format.l1r(DayOfWeekNames().p1u('Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'));
  $this$Format.i1r(', ');
  $this$Format.g1r(MonthNames().m1u('January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'));
  char($this$Format, _Char___init__impl__6a9atx(32));
  $this$Format.d1r(Padding_NONE_getInstance());
  $this$Format.i1r(', ');
  $this$Format.f1t(Padding_NONE_getInstance());
  char($this$Format, _Char___init__impl__6a9atx(58));
  $this$Format.h1t(Padding_ZERO_getInstance());
  char($this$Format, _Char___init__impl__6a9atx(32));
  $this$Format.g1t('AM', 'PM');
  return Unit_instance;
}
var FormatsClass;
function Formats() {
  if (FormatsClass === VOID) {
    class $ {
      constructor() {
        Formats_instance = this;
        var tmp = this;
        var tmp_0 = Companion_getInstance_0();
        tmp.j8z_1 = tmp_0.f27(Formats$mmddyyyy$lambda);
        var tmp_1 = this;
        var tmp_2 = Companion_getInstance_0();
        tmp_1.k8z_1 = tmp_2.f27(Formats$mmddyyyy_hmm$lambda);
        var tmp_3 = this;
        var tmp_4 = Companion_getInstance_0();
        tmp_3.l8z_1 = tmp_4.f27(Formats$hmm$lambda);
        var tmp_5 = this;
        var tmp_6 = Companion_getInstance_0();
        tmp_5.m8z_1 = tmp_6.f27(Formats$hmmss$lambda);
        var tmp_7 = this;
        var tmp_8 = Companion_getInstance_0();
        tmp_7.n8z_1 = tmp_8.f27(Formats$eeeddmmyyyy_hmm$lambda);
        var tmp_9 = this;
        var tmp_10 = Companion_getInstance_0();
        tmp_9.o8z_1 = tmp_10.f27(Formats$naturalEnglish$lambda);
      }
    }
    initMetadataForObject($, 'Formats');
    FormatsClass = $;
  }
  return FormatsClass;
}
var Formats_instance;
function Formats_getInstance() {
  if (Formats_instance === VOID)
    new (Formats())();
  return Formats_instance;
}
function formatRelative(_this__u8e3s4, includeTimestamp) {
  includeTimestamp = includeTimestamp === VOID ? true : includeTimestamp;
  _init_properties_timeFormatting_kt__wivjv6();
  var dateTime = toLocalDateTime(_this__u8e3s4, get_timeZone());
  var tmp0_subject = dateTime.v1w();
  var tmp;
  if (tmp0_subject.equals(get_today().v1w())) {
    tmp = includeTimestamp ? 'Today ' + format(dateTime, Formats_getInstance().l8z_1) : 'Today';
  } else if (tmp0_subject.equals(minus(get_today().v1w(), DatePeriod().o1m(VOID, VOID, 1)))) {
    tmp = includeTimestamp ? 'Yesterday ' + format(dateTime, Formats_getInstance().l8z_1) : 'Yesterday';
  } else {
    tmp = format(dateTime, includeTimestamp ? Formats_getInstance().k8z_1 : Formats_getInstance().j8z_1);
  }
  return tmp;
}
function formatLong(_this__u8e3s4) {
  _init_properties_timeFormatting_kt__wivjv6();
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().d1();
  var dateTime = toLocalDateTime(_this__u8e3s4, get_timeZone());
  this_0.wb(dateTime.g27().toString() + ' ' + dateTime.t1o() + ', ');
  this_0.wb('' + dateTime.r1o() + ', ');
  this_0.wb('' + (((dateTime.z1o() + 11 | 0) % 12 | 0) + 1 | 0) + ':' + padStart(dateTime.a1p().toString(), 2, _Char___init__impl__6a9atx(48)) + ' ' + ((dateTime.z1o() / 12 | 0) < 1 ? 'AM' : 'PM'));
  return this_0.toString();
}
var properties_initialized_timeFormatting_kt_7evqks;
function _init_properties_timeFormatting_kt__wivjv6() {
  if (!properties_initialized_timeFormatting_kt_7evqks) {
    properties_initialized_timeFormatting_kt_7evqks = true;
    timeZone = Companion_getInstance().q27();
    // Inline function 'com.lightningkite.now' call
    var tmp$ret$0 = get_default(Companion_instance).d1m();
    today = toLocalDateTime(tmp$ret$0, get_timeZone());
  }
}
//region block: exports
export {
  formatLong as formatLong1m1koxnp4gvzx,
  formatRelative as formatRelative8nj0p568e3ja,
  format_0 as format1crnfsffhjur0,
  Formats_getInstance as Formats_getInstance5hp5sczkglnx,
};
//endregion

//# sourceMappingURL=timeFormatting.mjs.map
